import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Link} from '@customink/pigment-react';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */ /** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function ServiceUnavailableNotification(props) {
  return (
    <Notification {...props} title="Oops!">
      <p className="ndx-cta1">
        The Design Lab is experiencing technical issues. Please try again later
        or{' '}
        <Link href="#/help" onClick={props.dismiss}>
          contact us for help
        </Link>
        .
      </p>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

ServiceUnavailableNotification.propTypes = propTypes;

ServiceUnavailableNotification.displayName = 'ServiceUnavailableNotification';
